import React from 'react';
import { Helmet } from 'react-helmet-async';

export const StructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "DrivingSchool",
    "name": "Top Driver Driving School",
    "image": "https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/jta8nfui_IMG_1207.jpeg",
    "@id": "https://topdriver.co.uk",
    "url": "https://topdriver.co.uk",
    "telephone": "+44 78 468 78 466",
    "email": "info@topdriver.co.uk",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "45 Bold Street",
      "addressLocality": "Liverpool",
      "addressRegion": "Merseyside",
      "postalCode": "L1 4HR",
      "addressCountry": "GB"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 53.4045,
      "longitude": -2.9860
    },
    "areaServed": {
      "@type": "City",
      "name": "Liverpool",
      "sameAs": "https://en.wikipedia.org/wiki/Liverpool"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "09:30",
        "closes": "20:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/share/17xT8fdr1N/?mibextid=wwXIfr",
      "https://youtube.com/@topdriveruk?si=WBDOPUGoNOvC_JVI",
      "https://www.instagram.com/topdriver_uk?igsh=bXI0ZDc3d21rYThr&utm_source=qr",
      "https://www.tiktok.com/@topdrivergb?_r=1&_t=ZN-93GnMY7ng3C"
    ],
    "priceRange": "£67 - £1,649",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "8",
      "reviewCount": "8"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Brenna Donnelly"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Arek is an amazing instructor, he made me feel relaxed and comfortable from my very first lesson! He was extremely professional and highly knowledgeable. I passed first time with the help of him. I'd highly recommend!"
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Edyta Janaszek"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Best instructor in Liverpool. Highly professional, always punctual, very patient and polite. Arek is also a great teacher. Passed on 1st attempt!"
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Harvey"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Arek is a very good instructor gave me lots of confidence. I passed first time because of him. Couldn't recommend him enough, amazing instructor!"
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Ania Sokołowska"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Arek is very professional, reliable, and at the same time friendly and patient. I went to every lesson not feeling stressed, but confident that I would learn something new. Calm, focused, and truly experienced, with a great approach to the student. I highly recommend him to anyone who is thinking about getting behind the wheel."
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Emilia Rumenova"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "The best driving instructor ever. His teaching style is very patient and calm. He helped me to build my confidence and made me feel comfortable behind the wheel."
      }
    ],
    "description": "Professional automatic driving lessons in Liverpool with a friendly DVSA-approved instructor. High pass rate, flexible times, and affordable prices. Book today with Top Driver."
  };

  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you offer automatic driving lessons in Liverpool?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, Top Driver specialises in automatic driving lessons in Liverpool. Automatic cars are easier to learn in because there is no clutch or gear changes, helping learners gain confidence faster."
        }
      },
      {
        "@type": "Question",
        "name": "How much do driving lessons cost in Liverpool?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our driving lesson prices are competitive and offer excellent value. We charge £45 for an hour session. That's the cheapest offer in Liverpool as other schools charge £50 per hour or more."
        }
      },
      {
        "@type": "Question",
        "name": "How many driving lessons will I need to pass?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The number of lessons depends on your previous experience and confidence level. On average, most learners need between 25-40 hours of lessons to reach test standard."
        }
      },
      {
        "@type": "Question",
        "name": "Do you teach beginner drivers?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we welcome complete beginners as well as learners with some experience. Lessons are structured to help you build skills step by step in a calm and supportive environment."
        }
      },
      {
        "@type": "Question",
        "name": "Are you a DVSA approved driving instructor?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, Top Driver is a DVSA-approved driving instructor, providing professional and safe driving lessons in Liverpool."
        }
      },
      {
        "@type": "Question",
        "name": "Do you offer intensive driving courses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We can arrange intensive or semi-intensive driving lessons depending on your availability and learning speed."
        }
      },
      {
        "@type": "Question",
        "name": "Which areas in Liverpool do you cover?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We provide driving lessons across Liverpool including Anfield, Everton, Bootle, Walton, Tuebrook, Kensington and Norris Green area."
        }
      },
      {
        "@type": "Question",
        "name": "Can nervous drivers learn with you?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we specialise in helping nervous drivers feel relaxed and confident behind the wheel with patient and friendly teaching methods."
        }
      },
      {
        "@type": "Question",
        "name": "Do you help prepare for the driving test?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we provide mock driving tests and full preparation so you feel confident and ready for your practical driving test."
        }
      },
      {
        "@type": "Question",
        "name": "How can I book driving lessons?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can book lessons by contacting us through the website or by phone. We will arrange a suitable time based on your availability."
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqStructuredData)}
      </script>
    </Helmet>
  );
};
